// @flow

import guid from './guid';

const sessionId = guid();

/**
 * Always returns the same unique guid for a given session
 *
 * @return {String} the guid
 */
export default () => sessionId;
